const articlesData = [
  {
    id: 1,
    title: 'A Look into How I Manage My Personal Projects (My Git/GitHub Workflow)',
    description:
      "I'll discuss how I create and manage my projects using Git/GitHub. Also, I'll be tackling how I use GitHub's project boards, issues, and pull requests...",
    published_at: 'MAY 15, 2020',
    link: 'https://dev.to/jorenrui/a-look-into-how-i-manage-my-personal-projects-my-git-github-workflow-1e7h'
  },
  {
    id: 2,
    title: '6 Ways to Deploy your Personal Websites / PHP+ MySQL Web Apps for Free',
    description:
      'Whether for deploying your personal project, your school project or for testing out your web apps, there are several web hosts in...',
    published_at: 'MAR 20, 2019',
    link:
      'https://dev.to/jorenrui/6-ways-to-deploy-your-personal-websites--php-mysql-web-apps-for-free-4m3a'
  },
  {
    id: 3,
    title: 'My Web Development Process Part 1: Design',
    description:
      'In building several web-based applications over a year, my process went through several changes. In the past, I went straight to code...',
    published_at: 'FEB 25, 2019',
    link: 'https://dev.to/jorenrui/my-web-development-process-part-1-design-7l1'
  }
];

export default articlesData;
